module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheada4-6895cd9b9a7b550360d324b5153bf4c8.jpg";